import { Injectable, inject } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthSessionService } from '../services/auth-session.service';

@Injectable()
export class AuthSessionInterceptor implements HttpInterceptor {
  private readonly authSession = inject(AuthSessionService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: unknown) => {
        if (error instanceof HttpErrorResponse && request.url.startsWith(environment.baseUrl)) {
          if (error.status === 401) {
            this.authSession.handleSessionExpired();
          }
          if (error.status === 403 && error.error?.code === 'SUBSCRIPTION_REQUIRED') {
            this.authSession.handleSubscriptionRequired();
          }
        }

        return throwError(() => error);
      })
    );
  }
}
